// extracted by mini-css-extract-plugin
module.exports = {"comingsoon":"CommentTab_comingsoon_37khH"};